import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubCategoryComponent } from './component/subCategory.component';

import { PipeModule } from 'src/app/shared/pipes/pipes.module';
import { EquisModule } from 'src/app/shared/equis.module';
import { SubCategoryRoutingModule } from './subcategory.routing.module';
import { ListModule } from 'src/app/shared/components/list/list.module';

@NgModule({
  declarations: [SubCategoryComponent],
  imports: [
    CommonModule,
    PipeModule,
    EquisModule,
    SubCategoryRoutingModule,
    ListModule,
  ],
  providers: [],
})
export class SubCategoryModule {}
